// extracted by mini-css-extract-plugin
export var active = "_cf-7";
export var container = "_cf-0";
export var evenWidth = "_cf-4";
export var large = "_cf-5";
export var outlet = "_cf-8";
export var slide = "_cf-2";
export var small = "_cf-6";
export var tab = "_cf-3";
export var tabs = "_cf-1";